export const DEFAULT_PAGE_SIZE = 10;
export const PAGINATION_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

/** Extract total row count for server-side DataGrid rowCount from API responses. */
export function extractPaginationTotal(response, fallbackLength = 0) {
  const root = response?.data ?? response;
  const data = root?.data ?? root;
  const pagination = data?.pagination ?? root?.pagination ?? data?.meta ?? root?.meta;

  const total = Number(
    pagination?.totalItems ??
      pagination?.totalRecords ??
      pagination?.total ??
      pagination?.totalDocs ??
      data?.totalItems ??
      data?.totalRecords ??
      data?.total ??
      data?.totalDocs ??
      data?.count ??
      root?.totalItems ??
      root?.totalRecords ??
      root?.total ??
      root?.totalDocs ??
      root?.count ??
      fallbackLength
  );

  return Number.isFinite(total) && total >= 0 ? total : fallbackLength;
}

